<template>
  <el-dialog
    title="Chú thích"
    :visible.sync="dialogNoteVisible"
    :close-on-click-modal="false"
    width="700px"
  >
    <slot></slot>
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; justify-content: flex-end"
    >
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="dialogNoteVisible = false"
        >
          {{ 'Đóng' }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogNoteVisible: false
    }
  },
  watch: {
    value(nv, ov) {
      this.dialogNoteVisible = nv
    },
    dialogNoteVisible(nv, ov) {
      if (!nv) {
        this.$emit('input', nv)
      }
    }
  }
}
</script>
